import { DataPoint } from '../utils/MarketDataGenerator';
import { useState, useRef } from 'react';
import { INITIAL_HISTORY_KEY } from '../utils/anchoredNav';

export function useMarketStream() {
  const [useRealData, setUseRealData] = useState(() => {
    const saved = localStorage.getItem('useRealData');
    try { if (saved !== null && saved !== "undefined") return JSON.parse(saved); } catch (e) { /* ignore */ } return true;
  });

  const [symbol, setSymbol] = useState(() => {
    return localStorage.getItem('symbol') || 'BTCUSDT';
  });

  const [isEditingSymbol, setIsEditingSymbol] = useState(false);
  const [realData, setRealData] = useState<DataPoint[] | null>(null);
  const [latencyMs, setLatencyMs] = useState<number | null>(null);
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [dataError, setDataError] = useState<string | null>(null);
  // F2: chave estável da navegação (AnchoredNav.keyOf); o App deriva a distância do fim. 0 com 'acompanhaPresente'.
  const [historyOffset, setHistoryOffset] = useState(INITIAL_HISTORY_KEY);
  const [isReturningToLive, setIsReturningToLive] = useState(false);
  const [isLoadingHistory, setIsLoadingHistory] = useState(false);
  const [hasReachedHistoryEnd, setHasReachedHistoryEnd] = useState(false);

  return {
    useRealData, setUseRealData, symbol, setSymbol, isEditingSymbol, setIsEditingSymbol, realData, setRealData, latencyMs, setLatencyMs, isLoadingData, setIsLoadingData, dataError, setDataError, historyOffset, setHistoryOffset, isReturningToLive, setIsReturningToLive, isLoadingHistory, setIsLoadingHistory, hasReachedHistoryEnd, setHasReachedHistoryEnd
  };
}
